import { render, staticRenderFns } from "./ContactFormComponent.vue?vue&type=template&id=4407747e&scoped=true&"
import script from "./ContactFormComponent.vue?vue&type=script&lang=ts&"
export * from "./ContactFormComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4407747e",
  null
  
)

export default component.exports